import {
  usePlayer,
  useRound,
  useStage,
} from "@empirica/core/player/classic/react";
import React from "react";
import { Avatar } from "./components/Avatar";
import { Timer } from "./components/Timer";
import { ProgressTracker } from "@/components/feedback/ProgressTracker";

// Define the game stages for the progress tracker
// Round 0: Familiarity Survey
// Round 1: Information Phase (Learning)
// Round 2: Role Instructions (Preparation)
// Round 3: Communication Phase (Discussion)
// Round 4: Comprehension Quiz
// Exit: Final Survey (no timer)
const GAME_STAGES = [
  { id: "survey", label: "Survey" },
  { id: "learning", label: "Learning" },
  { id: "preparation", label: "Preparation" },
  { id: "discussion", label: "Discussion" },
  { id: "quiz", label: "Quiz" },
  { id: "final", label: "Final Survey" },
];

export function Profile() {
  const player = usePlayer();
  const round = useRound();
  const stage = useStage();

  const score = player.get("score") || 0;
  const hideTimer = round?.get("hideTimer") || false;
  const currentRound = round?.get("current") || 0;
  const roundName = round?.get("name") || "";

  // Map round number to stage index (0=Survey, 1=Learning, 2=Discussion, 3=Quiz)
  const stageIndex = Math.min(currentRound, GAME_STAGES.length - 1);

  // Show subtitle for Information Phase
  const timerSubtitle = roundName === "Information Phase"
    ? "You can continue early if ready"
    : null;

  return (
    <div className="min-w-lg md:min-w-2xl mt-2 m-x-auto px-3 py-2 text-gray-500 rounded-md border-.5">
      {/* Progress Tracker */}
      <div className="mb-2">
        <ProgressTracker stages={GAME_STAGES} currentIndex={stageIndex} />
      </div>

      {/* Original profile row */}
      <div className="grid grid-cols-3 items-center">
        <div className="leading-tight ml-1">
          <div className="text-gray-600 font-semibold">
            {roundName}
          </div>
          <div className="text-blue-500 font-medium">
            {stage ? stage.get("name") : ""}
          </div>
        </div>

        {!hideTimer && <Timer subtitle={timerSubtitle} />}
        {hideTimer && <div />}

        <div className="flex space-x-3 items-center justify-end">
          {/* Score display hidden per user request */}
          {/* <div className="flex flex-col items-center">
            <div className="text-xs font-semibold uppercase tracking-wide leading-none text-gray-400">
              Score
            </div>
            <div className="text-3xl font-semibold !leading-none tabular-nums">
              {score}
            </div>
          </div> */}
          <div className="h-11 w-11">
            <Avatar player={player} />
          </div>
        </div>
      </div>
    </div>
  );
}
